import { render } from "./CadastrarTimbre.vue?vue&type=template&id=12c34aa8&scoped=true"
import script from "./CadastrarTimbre.vue?vue&type=script&lang=js"
export * from "./CadastrarTimbre.vue?vue&type=script&lang=js"

import "./CadastrarTimbre.vue?vue&type=style&index=0&id=12c34aa8&scoped=true&lang=css"

import exportComponent from "J:\\Centrion\\projetos\\apracam_ios\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12c34aa8"]])

export default __exports__